import * as angular from 'angular';
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {FulfillmentStepActionType} from "../../types/fulfillment-step-action.type";
import {FulfillmentStatusType} from "../../types/fulfillment-status.type";
import {FulfillmentStepStatusType} from "../../types/fulfillment-step-status.type";
import {ThreePLProviderType} from "../../../threePL/types/threePL-provider.type";
import {AttemptStatusType} from "../../types/attemptStatus.type";
import {FulfillmentSubTypeType} from "../../types/fulfillment-sub-type.type";
import {FulfillmentService} from "../../services/fulfillment-service.service";

export class FulfillmentLineStepActionMenuComponent implements IController {
  step: any;
  fulfillment: any;
  isShowSplitStepAction: boolean;
  isShowCreateVoucherAction: boolean;
  onSplit: Function;
  onDispatch: Function;
  onAutoAssign: Function;
  onAssignAgent: Function;
  onCancelService: Function;
  onCancelAttempt: Function;
  onAssignRoute: Function;
  onAddNote: Function;
  onCompleteManually: Function;
  onAssignResourceAllocation: Function;
  onCreateRoute: Function;
  onReset: Function;
  onDispatchExternal: Function;
  onCancelStep: Function;
  onCreateVoucher: Function;

  public FulfillmentStepActionType: typeof FulfillmentStepActionType = FulfillmentStepActionType;
  public fulfillmentStatusType: typeof FulfillmentStatusType = FulfillmentStatusType;
  public fulfillmentStepStatusType: typeof FulfillmentStepStatusType = FulfillmentStepStatusType;
  public attemptStatusType: typeof AttemptStatusType = AttemptStatusType;
  public threePLProviderType: typeof ThreePLProviderType = ThreePLProviderType;
  public serviceId: string;
  public serviceSubType: string;
  private serviceType: string;
  private serviceStatus: string;
  private attemptStatus: string;
  public actionsByStatusMap: any;
  public stepActions: any;
  private actions: any;
  private lastAttempt: any;
  public fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;


  constructor(private $timeout: ITimeoutService, private FulfillmentConstants, private fulfillmentService: FulfillmentService) {
  }

  $onInit() {
    this.actionsByStatusMap = this.FulfillmentConstants.fulfillmentStepAttemptsActionsByStatusMap;
    if (this.step && this.step.attempts) {
      this.lastAttempt = _.find(this.step.attempts, (a) => {
        return a.referenceId === this.step.referenceId;
      });

      this.serviceSubType = this.lastAttempt?.subType;
      this.serviceId = this.lastAttempt?.id;
      this.serviceType = this.lastAttempt?.type;
      this.serviceStatus = this.lastAttempt?.supplierStatus;
      this.attemptStatus = this.lastAttempt?.status;
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.step && !changes.step.isFirstChange()) {
      this.$onInit();
    }
  }

  onOpen($mdMenu, ev) {
    this.stepActions = this.fulfillmentService.fulfillmentsActions([this.step]);

    if (this.serviceSubType === this.fulfillmentSubTypeType.ThirdParty) {
      this.actions = this.actionsByStatusMap['ThirdPartyService'][this.attemptStatus];
    } else if (this.serviceType && this.serviceStatus) {
      this.actions = this.actionsByStatusMap[this.serviceType][this.serviceStatus];
      if (this.step?.pickup?.location?.address?.qualityGroup === 'Low' || this.step?.destination?.location?.address?.qualityGroup === 'Low') {
        this.actions = _.filter(this.actions, (a) => {
          return a.id !== this.FulfillmentStepActionType.AutoAssignAgent;
        })
      }
    }

    this.actions = _.filter(this.actions, (a) => {
      return !a.isBulk;
    });

    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });

  }

  onActionSelect(actionId, event) {
    if (actionId === this.FulfillmentStepActionType.AssignAgent) {
      this.onAssignAgent({serviceId: this.serviceId, $event: event, fulfillment: this.fulfillment})
    }
    if (actionId === this.FulfillmentStepActionType.AssignResourceAllocation) {
      this.onAssignResourceAllocation({serviceId: this.serviceId, $event: event, fulfillment: this.fulfillment})
    }
    if (actionId === this.FulfillmentStepActionType.AutoAssignAgent) {
      this.onAutoAssign({serviceId: this.serviceId, $event: event, fulfillment: this.fulfillment})
    }
    if (actionId === this.FulfillmentStepActionType.AssignToRoute) {
      this.onAssignRoute({serviceId: this.serviceId, $event: event, fulfillment: this.fulfillment})
    }
    if (actionId === this.FulfillmentStepActionType.CancelService) {
      this.onCancelService({
        serviceId: this.serviceId,
        serviceType: this.serviceType,
        $event: event,
        fulfillment: this.fulfillment,
        serviceSubType: this.serviceSubType
      })
    }
    if (actionId === this.FulfillmentStepActionType.CompleteManually) {
      this.onCompleteManually({stepId: this.step.id, $event: event})
    }
    if (actionId === this.FulfillmentStepActionType.AddNote) {
      this.onAddNote({serviceId: this.serviceId, $event: event, fulfillment: this.fulfillment, serviceSubType: this.serviceSubType})
    }
    if (actionId === this.FulfillmentStepActionType.CreateRoute) {
      this.onCreateRoute({serviceId: this.serviceId, $event: event, fulfillment: this.fulfillment})
    }
    if (actionId === this.FulfillmentStepActionType.Reset) {
      this.onReset({
        serviceId: this.serviceId, serviceType: this.serviceType, $event: event, fulfillment: this.fulfillment
      })
    }
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineStepActionMenu', {
    bindings: {
      step: '<',
      isShowSplitStepAction: '<',
      isShowCreateVoucherAction: '<',
      fulfillment: '<',
      onSplit: '&',
      onDispatch: '&',
      onAutoAssign: '&',
      onAssignAgent: '&',
      onCancelService: '&',
      onCancelAttempt: '&',
      onAssignRoute: '&',
      onAssignResourceAllocation: '&',
      onAddNote: '&',
      onReset: '&',
      onCreateRoute: '&',
      onCompleteManually: '&',
      onDispatchExternal: '&',
      onCancelStep: '&',
      onCreateVoucher: '&'
    },
    template: require('./fulfillment-line-step-action-menu.html').default,
    controller: FulfillmentLineStepActionMenuComponent
  });

